<template>
  <div v-if="dpe">
    <ProfileContainer
      :name="`${dpe.firstName} ${dpe.lastName}`"
      :phone="dpe.phone"
      :email="dpe.email"
    >
      <card class="basicCard">
        <div class="row">
          <div class="col-sm-1 text-center">
            <img
              id="profilePic"
              :src="profilePicPath"
              alt="Profile Picture"
              width="150"
              height="150"
            />
          </div>
          <div
            class="col-sm-10"
            style="display: flex; align-items: center; padding-left: 4em"
          >
            <div class="row">
              <div class="col-sm-12"><h5>DPE</h5></div>
              <div class="col-sm-12">
                <h1>
                  {{
                    `${dpe.firstName} ${dpe.lastName}${dpe.location ? ", " + dpe.location : ""}`
                  }}
                </h1>
              </div>
              <div class="col-sm-12">
                <h5>{{ dpe.certs }}</h5>
              </div>
            </div>
          </div>
          <!--          <div class="col-sm-1 align-items-center">-->
          <!--            <hilo-button-->
          <!--              styleType="grey"-->
          <!--              label="Documents"-->
          <!--              @click="goToDocuments"-->
          <!--            />-->
          <!--          </div>-->
        </div>
      </card>
      <!--      <card class="basicCard">-->
      <!--        <div class="row">-->
      <!--          <div-->
      <!--            class="col-sm-4"-->
      <!--            v-for="ride of featuredCheckrides"-->
      <!--            v-bind:key="ride.id"-->
      <!--          >-->
      <!--            <div class="customCard">-->
      <!--              <h5-->
      <!--                v-if="featuredCheckrides.indexOf(ride) === 0"-->
      <!--                class="cardTitles"-->
      <!--              >-->
      <!--                Last Checkride-->
      <!--              </h5>-->
      <!--              <h5-->
      <!--                v-else-if="featuredCheckrides.indexOf(ride) === 1"-->
      <!--                class="cardTitles"-->
      <!--              >-->
      <!--                Next Checkride-->
      <!--              </h5>-->
      <!--              <h5 v-else class="cardTitles">On Deck Checkride</h5>-->
      <!--              <h1 v-if="ride.cRNumber">CR {{ ride.cRNumber }}</h1>-->
      <!--              <h1 v-else>None</h1>-->
      <!--              <h5 v-if="ride.date" class="cardTitles">-->
      <!--                {{ ride.date.toLocaleDateString() }}-->
      <!--              </h5>-->
      <!--              <h5 v-else class="cardTitles">No Date</h5>-->
      <!--              <h5>{{ ride.description }}</h5>-->
      <!--              <hilo-button-->
      <!--                v-if="ride.id"-->
      <!--                styleType="grey"-->
      <!--                label="View Student"-->
      <!--                @click="goToStudent(ride.student)"-->
      <!--              />-->
      <!--              <hilo-button-->
      <!--                v-else-->
      <!--                styleType="grey"-->
      <!--                label="Schedule Checkride"-->
      <!--                @click="goToScheduleCheckride"-->
      <!--              />-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </card>-->
      <card class="basicCard">
        <div class="row">
          <div class="col-sm-4">
            <div class="customCard text-center payCard">
              <h1>Payroll ${{ payroll.amount }}</h1>
              <h6>
                Next Payroll Date:
                {{
                  payroll.paymentDate.toLocaleDateString(undefined, {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })
                }}
              </h6>
            </div>
          </div>
        </div>
      </card>
      <UpcomingSchedule :id="getId()" :idType="getIdType()" />
      <!--      <card class="basicCard">-->
      <!--        <div class="row">-->
      <!--          <div class="col-sm-3">-->
      <!--            <h5 class="cardTitles">School Name</h5>-->
      <!--            <h1>Schedule</h1>-->
      <!--            <hilo-button label="View Full Schedule"/>-->
      <!--          </div>-->
      <!--          <div class="col-sm-9">-->
      <!--            <div class="schedule">-->
      <!--              <div class="dayCard" v-for="day of upcomingSchedule" v-bind:key="day.id">-->
      <!--                <h5 class="cardTitles">-->
      <!--                  {{day.date.toString()[0]}}-->
      <!--                  <span style="float: right">-->
      <!--                    {{day.date.getDate()}}-->
      <!--                  </span>-->
      <!--                </h5>-->
      <!--                <h5 class="todayText" v-if="day.today">Today</h5>-->
      <!--                <div class="redBar" v-if="day.today" :style="cssVars"></div>-->
      <!--                <div>-->
      <!--                  <div class="scheduleRow" v-for="item of day.schedule" v-bind:key="item.name">-->
      <!--                    <div>-->
      <!--                      <h6>{{item.startTime}}-{{item.endTime}} <span class="floatRight">{{item.name}}</span></h6>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </card>-->
      <card class="basicCard">
        <HiloTable :columns="scheduledCheckrideColumns" :data="allCheckrides" />
      </card>
    </ProfileContainer>
  </div>
</template>
<script>
import { Icon, Select, Option } from "element-ui";
import HiloTable from "../../../components/HiloComponents/HiloTable.vue";
import dayjs from "dayjs";
import ProfileContainer from "../../../components/HiloComponents/ProfileContainer.vue";
import { useLoginStore } from "../../../stores/loginStore";
import HiloButton from "../../../components/HiloComponents/HiloButton.vue";
import UpcomingSchedule from "@/components/HiloComponents/UpcomingScheduleOld.vue";
import CheckridesAPIService from "@/servicehandlers/CheckridesAPIService";
const checkridesAPIService = new CheckridesAPIService();
export default {
  components: {
    UpcomingSchedule,
    //HiloButton,
    ProfileContainer,
    HiloTable,
    [Icon.name]: Icon,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  computed: {
    cssVars() {
      return {
        "--timeLoc": 25 + this.timeOffset() + "px",
      };
    },
  },
  data() {
    return {
      dpe: null,
      profilePicPath: null,
      allCheckrides: [],
      featuredCheckrides: [],
      payroll: null,
      upcomingSchedule: [],
      types: [],
      results: [],
      scheduledCheckrideColumns: [
        { key: "lastName", label: "Last Name" },
        { key: "firstName", label: "First Name" },
        { key: "type", label: "Type" },
        { key: "date", label: "Date" },
        { key: "startTime", label: "Start" },
        { key: "endTime", label: "End" },
        { key: "dpe", label: "DPE" },
        { key: "instructor", label: "Instructor" },
        { key: "tailNumber", label: "Tail Number" },
      ],
    };
  },
  mounted() {
    this.getDPE();
    this.getCheckrides();
    this.getPayroll();
    this.getUpcomingSchedule();
    this.getTypes();
    this.getResults();
  },
  methods: {
    getDPE() {
      const store = useLoginStore();
      const user = store.getUser;

      let location = "";
      if (user.city && user.state) {
        location = `${user.city}, ${user.state}`;
      } else if (user.state) {
        location = user.state;
      }

      const certAcronyms =
        user.userProgramCerts?.map((cert) => cert.program.acronym) || [];

      this.dpe = {
        ...user,
        certs: certAcronyms.join(", "),
        location,
        lastCheckrideId: 1,
      };
      this.getProfilePic();
    },
    getId() {
      const store = useLoginStore();
      const user = store.getUser;
      return this.$route.params.id ? this.$route.params.id : user.id;
    },
    getIdType() {
      return this.$route.params.id ? "dpeId" : "userId";
    },
    getProfilePic() {
      this.profilePicPath = "/static/img/faces/face-0.jpg";
    },
    // getCheckrides() {
    //   let students = [
    //     {
    //       id: 47,
    //       firstName: "John",
    //       lastName: "Doe",
    //       fullName: "John Doe",
    //       ftnNumber: "FTN123",
    //       certNumber: "CERT456",
    //       score: 85,
    //       phoneNumber: "123-456-7890",
    //     },
    //     {
    //       id: 82,
    //       firstName: "Jane",
    //       lastName: "Smith",
    //       fullName: "Jane Smith",
    //       ftnNumber: "FTN456",
    //       certNumber: "CERT789",
    //       score: 92,
    //       phoneNumber: "987-654-3210",
    //     },
    //     {
    //       id: 19,
    //       firstName: "Michael",
    //       lastName: "Johnson",
    //       fullName: "Michael Johnson",
    //       ftnNumber: "FTN789",
    //       certNumber: "CERT123",
    //       score: 78,
    //       phoneNumber: "555-123-4567",
    //     },
    //     {
    //       id: 63,
    //       firstName: "Emily",
    //       lastName: "Brown",
    //       fullName: "Emily Brown",
    //       ftnNumber: "FTN234",
    //       certNumber: "CERT567",
    //       score: 89,
    //       phoneNumber: "222-987-6543",
    //     },
    //     {
    //       id: 35,
    //       firstName: "David",
    //       lastName: "Martinez",
    //       fullName: "David Martinez",
    //       ftnNumber: "FTN567",
    //       certNumber: "CERT890",
    //       score: 91,
    //       phoneNumber: "777-555-4321",
    //     },
    //     {
    //       id: 91,
    //       firstName: "Sarah",
    //       lastName: "Lee",
    //       fullName: "Sarah Lee",
    //       ftnNumber: "FTN890",
    //       certNumber: "CERT234",
    //       score: 86,
    //       phoneNumber: "999-333-2222",
    //     },
    //     {
    //       id: 12,
    //       firstName: "Kevin",
    //       lastName: "Garcia",
    //       fullName: "Kevin Garcia",
    //       ftnNumber: "FTN345",
    //       certNumber: "CERT678",
    //       score: 83,
    //       phoneNumber: "444-666-8888",
    //     },
    //     {
    //       id: 56,
    //       firstName: "Jessica",
    //       lastName: "Lopez",
    //       fullName: "Jessica Lopez",
    //       ftnNumber: "FTN678",
    //       certNumber: "CERT901",
    //       score: 95,
    //       phoneNumber: "111-222-3333",
    //     },
    //     {
    //       id: 28,
    //       firstName: "Ryan",
    //       lastName: "Taylor",
    //       fullName: "Ryan Taylor",
    //       ftnNumber: "FTN901",
    //       certNumber: "CERT345",
    //       score: 88,
    //       phoneNumber: "666-999-1111",
    //     },
    //     {
    //       id: 74,
    //       firstName: "Amanda",
    //       lastName: "Wilson",
    //       fullName: "Amanda Wilson",
    //       ftnNumber: "FTN456",
    //       certNumber: "CERT789",
    //       score: 90,
    //       phoneNumber: "333-777-5555",
    //     },
    //   ];
    //   let startID = 7;
    //   let today = new Date();
    //   for (let i = 0; i < students.length; i++) {
    //     if (i !== 0) {
    //       today = this.allCheckrides[i - 1].date;
    //     }
    //     this.allCheckrides[i] = {
    //       id: i + 1,
    //       cRNumber: i + startID,
    //       date: addRandomDaysAndTime(today),
    //       description:
    //         "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore",
    //       student: students[i],
    //       instructor: {
    //         id: 1,
    //         firstName: "Tyler",
    //         lastName: "Johnson",
    //         full_name: "Tyler Johnson",
    //       },
    //       selected: false,
    //       typeID: 4,
    //       tailNumber: "N3216R",
    //       resultID: 1,
    //     };
    //   }
    //   function addRandomDaysAndTime(date) {
    //     // Generate a random number of days (between 1 and 30 for example)
    //     let randomDays = Math.floor(Math.random() * 30) + 1;
    //
    //     // Convert days to milliseconds
    //     let randomDaysInMillis = randomDays * 24 * 60 * 60 * 1000;
    //
    //     // Create a new Date with added random days
    //     let newDate = new Date(date.getTime() + randomDaysInMillis);
    //
    //     // Generate random time (hours, minutes, seconds, milliseconds)
    //     let hours = Math.floor(Math.random() * 24);
    //     let minutes = Math.floor(Math.random() * 60);
    //     let seconds = Math.floor(Math.random() * 60);
    //     let milliseconds = Math.floor(Math.random() * 1000);
    //
    //     // Set the random time to the new Date object
    //     newDate.setHours(hours, minutes, seconds, milliseconds);
    //
    //     return newDate;
    //   }
    //   this.buildFeaturedList();
    // },
    getCheckrides() {
      return checkridesAPIService
        .get(this.$router)
        .then((response) => {
          this.allCheckrides = response
            .map((checkride) => {
              checkride.lastName =
                checkride.activeStudent?.user.lastName || "-";
              checkride.firstName =
                checkride.activeStudent?.user.firstName || "-";
              checkride.status = checkride.checkrideSchedulingStatus?.name;
              checkride.type = checkride.program?.name;

              checkride.date = checkride.startDateTime
                ? dayjs(checkride.startDateTime).format("MM/DD/YYYY")
                : "-";
              checkride.startTime = checkride.startDateTime
                ? dayjs(checkride.startDateTime).format("h:mm A")
                : "-";
              checkride.endTime = checkride.endDateTime
                ? dayjs(checkride.endDateTime).format("h:mm A")
                : "-";

              const dpe = checkride.dpe?.user;
              checkride.dpe = dpe ? `${dpe.firstName} ${dpe.lastName}` : "-";
              checkride.dpeEmail = dpe ? dpe.email : "-";

              const instructor = checkride.activeInstructor?.user;
              checkride.instructor = instructor
                ? `${instructor.firstName} ${instructor.lastName}`
                : "-";

              checkride.tailNumber = checkride.aircraft?.tailNumber || "-";

              return checkride;
            })
            .filter((checkride) => checkride.status === "Scheduled");
        })
        .catch(() => {});
    },
    getPayroll() {
      this.payroll = {
        paymentDate: new Date("04/20/2024"),
        amount: 1200,
        periodStart: new Date("04/01/2024"),
        periodEnd: new Date("04/15/2024"),
      };
    },
    getUpcomingSchedule() {
      let today = new Date();
      let tomorrow = new Date();
      let nextDay = new Date();
      let dayAfter = new Date();
      let lastDay = new Date();
      tomorrow.setDate(today.getDate() + 1);
      nextDay.setDate(tomorrow.getDate() + 1);
      dayAfter.setDate(nextDay.getDate() + 1);
      lastDay.setDate(dayAfter.getDate() + 1);
      let temp = [
        {
          startTime: 6,
          startM: "AM",
          endTime: 12,
          endM: "AM",
          name: "Ground",
        },
        {
          startTime: 12,
          startM: "AM",
          endTime: 2,
          endM: "PM",
          name: "Study",
        },
        {
          startTime: 2,
          startM: "PM",
          endTime: 4,
          endM: "PM",
          name: "Flight",
        },
        {
          startTime: 4,
          startM: "PM",
          endTime: 7,
          endM: "PM",
          name: "Debrief",
        },
      ];
      this.upcomingSchedule = [
        {
          id: 1,
          today: true,
          date: today,
          schedule: temp,
        },
        {
          id: 2,
          today: false,
          date: tomorrow,
          schedule: temp,
        },
        {
          id: 3,
          today: false,
          date: nextDay,
          schedule: temp,
        },
        {
          id: 4,
          today: false,
          date: dayAfter,
          schedule: temp,
        },
        {
          id: 5,
          today: false,
          date: lastDay,
          schedule: temp,
        },
      ];
    },
    getTypes() {
      this.types = [
        {
          id: 1,
          name: "PPL",
        },
        {
          id: 2,
          name: "IR",
        },
        {
          id: 3,
          name: "CPL",
        },
        {
          id: 4,
          name: "CFI",
        },
        {
          id: 5,
          name: "CFII",
        },
        {
          id: 6,
          name: "MEI",
        },
      ];
    },
    getResults() {
      this.results = [
        {
          id: 1,
          name: "Pass",
        },
        {
          id: 2,
          name: "Disapproval",
        },
        {
          id: 3,
          name: "Discontinuance",
        },
      ];
    },
    buildFeaturedList() {
      let empty = {
        id: null,
        cRNumber: null,
        date: null,
        description: "No Scheduled Checkride",
        student: null,
        instructor: null,
      };
      let last;
      let next;
      let onDeck;
      for (let ride of this.allCheckrides) {
        if (next) {
          onDeck = ride;
          break;
        }
        if (last) {
          next = ride;
        }
        if (ride.id === this.dpe.lastCheckrideId) {
          last = ride;
        }
      }
      if (last) {
        this.featuredCheckrides.push(last);
      } else {
        this.featuredCheckrides.push(empty);
      }
      if (next) {
        this.featuredCheckrides.push(next);
      } else {
        this.featuredCheckrides.push(empty);
      }
      if (onDeck) {
        this.featuredCheckrides.push(onDeck);
      } else {
        this.featuredCheckrides.push(empty);
      }
    },
    goToDocuments() {
      alert("Went to documents page!");
    },
    goToStudent(student) {
      alert("Went to " + student.fullName + "'s page!");
    },
    goToScheduleCheckride() {
      alert("Went to Schedule Checkride page!");
    },
    timeOffset() {
      let first = 0;
      let last = 20;
      let today = new Date();
      let hours = today.getHours() + today.getMinutes() / 60;
      for (let item of this.upcomingSchedule[0].schedule) {
        let temp = item;
        if (item.startM === "PM") {
          if (temp.startTime !== 12) {
            temp.startTime = temp.startTime + 12;
          }
        }
        if (item.endM === "PM") {
          if (temp.endTime !== 12) {
            temp.endTime = temp.endTime + 12;
          }
        }
        if (temp.startTime > hours) break;
        if (temp.startTime <= hours && temp.endTime >= hours) {
          let amount =
            (hours - temp.startTime) / (temp.endTime - temp.startTime);
          amount = Math.floor(amount * last) + first;
          if (item.startM === "PM") {
            temp.startTime = temp.startTime - 12;
          }
          if (item.endM === "PM") {
            temp.endTime = temp.endTime - 12;
          }
          return amount;
        } else {
          first += last;
        }
        if (item.startM === "PM") {
          temp.startTime = temp.startTime - 12;
        }
        if (item.endM === "PM") {
          temp.endTime = temp.endTime - 12;
        }
      }
      return first;
    },
    toggle(item) {
      item.selected = !item.selected;
    },
  },
};
</script>
<style scoped>
h1,
h5,
h6 {
  margin: 0;
}
p {
  font-size: 16px;
  padding: 1em 1em;
}
h1 {
  font-weight: bold;
}
h5 {
  color: grey;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
td,
tr {
  padding: 0;
  margin: 0;
  border: none;
}
el-input {
  border: none;
  background-color: transparent;
  color: #3fc4e7;
}
.basicCard {
  margin: 1em 2em;
  border-color: transparent;
}
#profilePic {
  padding: 0.25em;
  border-radius: 1em;
}
.cardTitles {
  padding: 0;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: black;
}
.align-items-center {
  display: flex;
  align-items: center;
}
.text-center {
  text-align: center;
}
.customCard {
  width: 100%;
  height: 100%;
  align-content: space-evenly;
  background-color: #f0f0f0;
  border-radius: 2em;
  padding: 1em 1.5em;
}
.payCard {
  color: white;
  background-color: #2ab472;
}
.daysLeft h5 {
  color: black;
  margin: 0;
  padding: 0;
}
.daysLeft h2 {
  margin-top: -5px;
  transform: scale(1, 0.75);
}
.schedule {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 3em;
}
.dayCard {
  display: inline-block;
  border: #f0f0f0 3px solid;
  border-radius: 1.5em;
  padding: 1em 1.5em;
}
.todayText {
  font-size: 14px;
  color: #dd2025;
  float: right;
  padding: 0;
  margin: -5px 2px;
}
.scheduleRow {
  padding: 0 1.5em;
  margin: 0 -1.5em;
  font-size: 18px;
  height: 20px;
}
.scheduleRow:first-child {
  margin-top: 25px;
}
.scheduleRow:nth-child(odd) {
  background-color: #f0f0f0;
}
.redBar {
  height: 2px;
  margin: 0 -1.5em;
  background-color: #dd2025;
  position: relative;
  top: var(--timeLoc);
}
button {
  border-style: solid;
}
.floatRight {
  float: right;
}
</style>
